import type { ColorScheme } from '@blocksuite/affine-model';
import { createContext } from '@lit/context';
import type { Subject } from 'rxjs';

import type { MenuPopper } from './create-popper.js';

export interface EdgelessToolbarSlots {
  resize: Subject<{ w: number; h: number }>;
}

export const edgelessToolbarSlotsContext = createContext<EdgelessToolbarSlots>(
  Symbol('edgelessToolbarSlotsContext')
);

export const edgelessToolbarThemeContext = createContext<ColorScheme>(
  Symbol('edgelessToolbarThemeContext')
);

/** What a dock entry coordinates with its dock: one open entry menu at a time. */
export interface EdgelessDockPort {
  activePopper: MenuPopper<HTMLElement> | null;
}

/** Closes the entry menu that is open in the dock, whichever entry owns it. */
export function closeActiveDockMenu(port: EdgelessDockPort) {
  port.activePopper?.dispose();
  port.activePopper = null;
}

/**
 * An entry menu stays open only while the tool in use is one its entry holds:
 * a menu that picked its own tool stays, a switch to any other tool closes it.
 */
export function shouldCloseMenuOnToolSwitch(
  menuOpen: boolean,
  entryHoldsTool: boolean
) {
  return menuOpen && !entryHoldsTool;
}

export const edgelessToolbarContext = createContext<EdgelessDockPort>(
  Symbol('edgelessToolbarContext')
);
